import PropTypes from "prop-types";
import Notification from "components/Notification";

export const defaultNotificationCodes = new Set([
    "error404",
    "error405",
    "error500",
    "generalError",
    "malformedRequest",
    "listingNoData",
    "validation_failed",
]);

/**
 * Notification Manager - Default System Notifications
 * @return {Node} Returns Notification component
 */
const DefaultNotifications = ({ identifier, code, detail }) => {
    switch (code) {
        case "error404":
            return (
                <Notification
                    identifier={identifier}
                    title="Error"
                    text="404 (Not Found). Please try to refresh the page."
                    type="error"
                />
            );
        case "error405":
            return (
                <Notification
                    identifier={identifier}
                    title="Error"
                    text="405 (Method Not Allowed). Please try to refresh the page."
                    type="error"
                />
            );
        case "error500":
            return (
                <Notification
                    identifier={identifier}
                    title="Error"
                    text="500 (Internal Server Error). Please try to refresh the page."
                    type="error"
                />
            );
        case "generalError":
            return (
                <Notification
                    identifier={identifier}
                    title="Error"
                    text={<strong>{code}</strong>}
                    type="error"
                />
            );
        case "malformedRequest":
            return (
                <Notification
                    identifier={identifier}
                    title="Error"
                    text="The request you made was malformed!"
                    type="error"
                />
            );
        case "listingNoData":
            return (
                <Notification
                    identifier={identifier}
                    title="No Results"
                    text="There are no results to display!"
                    type="info"
                />
            );
        case "validation_failed":
            return (
                <Notification
                    identifier={identifier}
                    title="Error"
                    text={detail}
                    type="error"
                    expire="3500"
                />
            );
        default:
            return null;
    }
};

DefaultNotifications.defaultProps = {
    identifier: null,
    code: null,
    detail: null,
};

DefaultNotifications.propTypes = {
    identifier: PropTypes.string,
    code: PropTypes.string,
    detail: PropTypes.string,
};

export default DefaultNotifications;
